import { UserServiceProvider } from '../../../shared/services/user/user.service';

(() => {
	angular.module('main').controller('ContractsController', ContractsController);

	ContractsController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'$filter',
		'messageService',
		'validationService',
		'accountService'
	];

	function ContractsController(
		$scope,
		$rootScope,
		$http,
		$filter,
		messageService,
		validationService,
		accountService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isUpdateSpinnningWheelActive = false;
			$scope.isDelateSpinnningWheelActive = false;
			$scope.isEditSpinnningWheelActive = false;
			$scope.isDuplicateSpinnningWheelActive = false;
		});
		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		$scope.save = function() {
			$scope.isUpdateSpinnningWheelActive = true;

			if (validationService.isStringEmpty($scope.updatecontract.name)) {
				messageService.showToaster('e_3', 'general', 'Name');
				$scope.isUpdateSpinnningWheelActive = false;
				return;
			}

			if (
				$scope.updatecontract.showOtpInConsent &&
				validationService.isStringEmpty(
					$scope.updatecontract.optInConsentStatement
				)
			) {
				messageService.showToaster('e_3', 'general', 'Opt-in consent');
				$scope.isUpdateSpinnningWheelActive = false;
				return;
			}

			$('#updateModal').modal('hide');
			const item = $scope.updatecontract;
			item.text = $rootScope.addMaiStyling(item.text);
			$http({
				method: 'POST',
				url: '/protected/rest/contracts/update',
				data: item
			})
				.then(result => {
					if (result.data) {
						if (result.data.message) {
							const successMsgCode = item.id ? 's_2' : 's_1';
							messageService.showToaster(
								successMsgCode,
								'contractTemplates',
								item.name
							);
						} else if (result.data.errorMessage) {
							toastr.error(result.data.errorMessage);
						}
					}
				})
				.catch(result => {
					messageService.showToaster('e_0', 'general');
				})
				.finally(result => {
					$scope.isUpdateSpinnningWheelActive = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				});
		};
		$scope.showOptIn = function(value) {
			$scope.updatecontract.showOtpInConsent = value;
		};

		$scope.deleteContract = function(id) {
			delete $scope.updatecontract;
			const contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);
			$('#deleteModal').modal();
		};

		$scope.confirmDeleteContract = function(id) {
			$scope.isDelateSpinnningWheelActive = true;
			$('#deleteModal').modal('hide');
			console.log($scope.updatecontract);
			const item = $scope.updatecontract;

			$http({
				method: 'POST',
				url: '/protected/rest/contracts/delete',
				data: item
			})
				.then(result => {
					successDeleteContract();
				})
				.catch(result => errorDeleteContract(result.data))
				.finally(() => {
					$scope.isDelateSpinnningWheelActive = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				});
		};

		function successDeleteContract() {
			messageService.showToaster('s_0', 'contract');
		}

		function errorDeleteContract(data) {
			const errorMessage = data.errorMessage;
			if (errorMessage && errorMessage.includes('used in workflow template')) {
				messageService.showToaster('e_1', 'contract');
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.duplicate = function(id) {
			delete $scope.updatecontract;
			$scope.isDuplicateSpinnningWheelActive = true;

			const contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);
			console.log($scope.updatecontract);
			if ($scope.updatecontract) {
				$scope.updatecontract.id = null;
				$scope.modal_description = 'Duplicate contract';
				$scope.modal_title = 'Duplicate contract';
			}
			$('#updateModal').modal();
			$scope.isDuplicateSpinnningWheelActive = false;
		};
		$scope.update = function(id) {
			delete $scope.updatecontract;
			$scope.isEditSpinnningWheelActive = true;
			const contract = findById(id, $scope.contracts);
			$scope.updatecontract = angular.copy(contract);
			console.log($scope.updatecontract);
			if ($scope.updatecontract) {
				$scope.modal_description = 'Update contract';
				$scope.modal_title = 'Update contract';
			} else {
				$scope.modal_description = 'Add a new contract';
				$scope.modal_title = 'Add a new contract';
			}
			$scope.isEditSpinnningWheelActive = false;
			$('#updateModal')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};
		$scope.$on('$viewContentLoaded', () => {
			$('body').updatePolyfill();
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.totalItems = 0;
			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});
		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Contract Templates' }
		];

		function findById(id, array) {
			if (!id) {
				id = null;
			}
			let found = null;
			found = $filter('filter')(
				array,
				{
					id
				},
				true
			);
			if (found && found.length) {
				console.log(found[0]);
				const contract = found[0];
				return contract;
			}
			console.log('Not found');
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			console.log('get packages data');

			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate != null &&
				typeof reverse !== 'undefined' &&
				reverse != null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http
					.get(
						`/protected/rest/contracts?perPage=${
							$scope.pageRequest.perPage
						}&page=${$scope.pageRequest.page}&predicate=${
							$scope.pageRequest.pageOrder.predicate
						}&reverse=${$scope.pageRequest.pageOrder.reverse}`
					)
					.then(result => {
						$scope.gdprEnabled = result.data.gdprEnabled;
						if (result.data && result.data.pageRequest) {
							$scope.pageRequest = result.data.pageRequest;
						}
						$scope.pageNumbers = [];
						$scope.totalItems = result.data.total;
						let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
						pagesCount = Math.ceil(pagesCount);
						for (let i = 1; i <= pagesCount; i++) {
							$scope.pageNumbers[i - 1] = i;
						}
						$scope.contracts = result.data.results;
						console.log(result);
					});
			}
		}

		$scope.disableDragDrop = function() {
			return true;
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/contractsController.js